import React from 'react';
import T from 'prop-types';
import Tooltip from '@splunk/react-ui/Tooltip';

// css prop line-height needs to be zero to prevent Tooltip from adding un-necessary height.
const tooltipStyle = { lineHeight: 0 };

/**
 * Component for tooltip that is a middle layer between it's children.
 */
const OptionalTooltip = ({
    children = null,
    message,
}: {
    children: React.ReactNode;
    message?: string;
}): React.ReactNode => {
    if (!message) {
        return children;
    }

    return (
        <Tooltip
            content={message}
            defaultPlacement="below"
            style={tooltipStyle}
        >
            {children}
        </Tooltip>
    );
};

OptionalTooltip.propTypes = {
    children: T.node,
    message: T.string,
};

export default OptionalTooltip;
